import React, { memo, useContext } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';

const CtxLink = props => {
  const { renderMode } = useContext(AppContext);
  const legacyRenderMode = ['desktop', 'mobile', 'native'].includes(renderMode);
  if (legacyRenderMode) {
    return <a href={props.to}>{props.children}</a>;
  }
  return <Link to={props.to}>{props.children}</Link>;
};

CtxLink.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default memo(CtxLink);
